export enum RouteScheduleClashSeverity {
  None = 'none',
  Partial = 'partial',
  Current = 'current',
  Definite = 'definite',
}
